import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, model, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { provideNativeDateAdapter } from '@angular/material/core';
import { DateRange, MatDatepickerInputEvent, MatDateRangeInput, MatDateRangePicker } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { end } from '@popperjs/core';
import { LegendPosition } from '@swimlane/ngx-charts';
import { finalize } from 'rxjs';
import { ApiService } from 'src/app/services/api/api.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ModalService } from 'src/app/services/modal-service/modal.service';
import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';

@Component({
  selector: 'app-asset-management-dashboard',
  standalone: false,
  templateUrl: './asset-management-dashboard.component.html',
  styleUrl: './asset-management-dashboard.component.scss'
})
export class AssetManagementDashboardComponent {
  @ViewChild('rangeInput') rangeInput!: MatDateRangeInput<Date>;

  activePeriodFilter: string = 'TODAY';
  filterOpen: boolean = false;



  date: any;

  page: number = 0;
  num: number = 1;
  currentPage: number = 1;
  count: number = 0;
  pageSize: number = 10;
  selectedLimit: number = 10;
  legendPosition = LegendPosition;

  totalAssetCount: number;
  rangePickerForm: FormGroup;



  constructor(
    private location: Location,
    private apiService: ApiService,
    private authService: AuthService,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private modalService: ModalService
  ) {

  }

  ngOnInit(): void {
    const queryParams = this.route.snapshot.queryParams;
    const { period, startDate, endDate } = queryParams;



    this.rangePickerForm = this.formBuilder.group({
      startDate: null,
      endDate: null,
    })

    const payload: any = { period: period || 'TODAY' };

    if (period === 'DATE_RANGE' && startDate && endDate) {
      payload.startDate = startDate;
      payload.endDate = endDate;

      this.rangePickerForm.patchValue({ startDate: new Date(startDate), endDate: new Date(endDate) })
    }

    // this.fetchassetCount(payload);
    // this.fetchSummaryChartData(payload);
    // this.fetchTransactionHistory(payload)

    this.setActiveFilter(payload);
    this.fetchassetCount(payload);

  }


  // Date Range Filter
  maxRangeInDays = 7;

  dateRangeFilter = (date: Date | null): boolean => {
    if (!date) return false;

    const start = this.rangePickerForm?.get('start')?.value;
    if (!start) return true; // No start date yet, allow all dates

    const maxEndDate = new Date(start);
    maxEndDate.setDate(maxEndDate.getDate() + (this.maxRangeInDays - 1));

    return date <= maxEndDate;
  };


  onDateChange(event: any) {
    const start = this.rangePickerForm.value?.startDate;
    const end = this.rangePickerForm.value?.endDate;
    const maxDateRange = 7;


    if (start && end) {
      // Validate Max Date
      const diffInMs = Math.abs(end.getTime() - start.getTime());
      const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

      if (diffInDays > (maxDateRange - 1)) { // 7 calendar days = 6 days difference
        console.warn('Selected range exceeds 7 days');

        // Set error on end date
        const endControl = this.rangePickerForm.get('endDate');
        endControl?.setErrors({ maxDateRange });
        endControl?.markAsTouched();
      }


      this.setActiveFilter(
        {
          period: 'DATE_RANGE',
          startDate: this.formatDateToYMD(start),
          endDate: this.formatDateToYMD(end),
        }
      )

    } else {

    }
  }



  toggleFilterOpen() {
    this.filterOpen = !this.filterOpen
  }


  // single: any[] = [
  //   {
  //     "name": "Germany",
  //     "value": 8940000
  //   },
  //   {
  //     "name": "USA",
  //     "value": 5000000
  //   },
  //   {
  //     "name": "France",
  //     "value": 7200000
  //   }
  // ];
  transactionsByStatus: any[] = [
    {
      name: "Approved Transactions",
      series: [
        { name: "Mon", value: 62000000 },
        { name: "Tue", value: 48000000 },
        { name: "Wed", value: 54000000 },
        { name: "Thu", value: 20000000 },
        { name: "Fri", value: 25000000 },
        { name: "Sat", value: 30000000 },
        { name: "Sun", value: 41000000 },
      ],
    },
    {
      name: "Initiations Transactions",
      series: [
        { name: "Mon", value: 15000000 },
        { name: "Tue", value: 32000000 },
        { name: "Wed", value: 44000000 },
        { name: "Thu", value: 30000000 },
        { name: "Fri", value: 32000000 },
        { name: "Sat", value: 27000000 },
        { name: "Sun", value: 35000000 },
      ],
    },
    {
      name: "Failed Transactions",
      series: [
        { name: "Mon", value: 7000000 },
        { name: "Tue", value: 9000000 },
        { name: "Wed", value: 11000000 },
        { name: "Thu", value: 13000000 },
        { name: "Fri", value: 17000000 },
        { name: "Sat", value: 20000000 },
        { name: "Sun", value: 14000000 },
      ],
    },
  ];

  multi: any[] = [
    {
      "name": "Mon",
      "series": [
        {
          "name": "Initiated Transactions",
          "value": 2800000
        },
        {
          "name": "Approved Transactions",
          "value": 2600002
        },
      ]
    },

    {
      "name": "Teu",
      "series": [
        {
          "name": "Initiated Transactions",
          "value": 2800000
        },
        {
          "name": "Approved Transactions",
          "value": 2600002
        },

      ]
    },

    {
      "name": "Wed",
      "series": [
        {
          "name": "Initiated Transactions",
          "value": 5800000
        },
        {
          "name": "Approved Transactions",
          "value": 5000002
        },

      ]
    },

    {
      "name": "Thurs",
      "series": [
        {
          "name": "Initiated Transactions",
          "value": 5500000
        },
        {
          "name": "Approved Transactions",
          "value": 510002
        },

      ]
    },

    {
      "name": "Fri",
      "series": [
        {
          "name": "Initiated Transactions",
          "value": 2800000
        },
        {
          "name": "Approved Transactions",
          "value": 2600002
        },

      ]
    },
    {
      "name": "Sat",
      "series": [
        {
          "name": "Initiated Transactions",
          "value": 4200000
        },
        {
          "name": "Approved Transactions",
          "value": 3000002
        },

      ]
    },

    {
      "name": "Sun",
      "series": [
        {
          "name": "Initiated Transactions",
          "value": 4200000
        },
        {
          "name": "Approved Transactions",
          "value": 3000002
        },

      ]
    },
  ];


  convertPeriodToFrequency(label: string): string {
    switch (label.toUpperCase()) {
      case 'TODAY':
        return 'DAILY';
      case 'WEEK':
        return 'WEEKLY';
      case 'MONTH':
        return 'MONTHLY';
      case 'YEAR':
        return 'YEARLY';
      case 'DATE_RANGE':
        return 'DATE_RANGE';
      default:
        return 'UNKNOWN'; // or throw an error, or return null/empty string
    }
  }

  view: [number, number] = [null, 400];

  // options
  showXAxis: boolean = true;
  showYAxis: boolean = true;
  gradient: boolean = true;
  showLegend: boolean = true;
  showXAxisLabel: boolean = true;
  showYAxisLabel: boolean = true;



  lineChartColorScheme: any = {
    domain: ['#0CA811', '#FFD829', '#CE2A2D']
  };

  barChartColorScheme: any = {
    domain: ['#9CD1A7', '#0CA811', '#045C07']
  };







  onSelect(event) {

  }




  setActiveFilter(payload: any) {

    const period = payload?.period;
    this.activePeriodFilter = period;

    if (period !== 'DATE_RANGE') {
      this.rangePickerForm.reset();
    }
    else {
      if (this.rangePickerForm.invalid) {
        return;
      }
    }


    this.fetchassetCount(payload)
    this.fetchSummaryChartData(payload);


    const queryParams: any = {
      period
    };

    if (payload.startDate) {
      queryParams.startDate = payload.startDate;
    } else {
      queryParams.startDate = null;
    }

    if (payload.endDate) {
      queryParams.endDate = payload.endDate;
    } else {
      queryParams.endDate = null;
    }

    this.router.navigate([], {
      queryParams,
      queryParamsHandling: 'merge'
    });

    this.filterOpen = false;

    this.currentPage = 1;

  }


  formatActiveFilterTitle(filter: any) {


    switch (filter?.toUpperCase()) {

      case 'DATE_RANGE': {
        const startDate = this.rangePickerForm.value?.startDate?.toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric'
        });;

        const endDate = this.rangePickerForm.value?.endDate?.toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric'
        });;



        return `${startDate} - ${endDate}`;
      }
      default:
        return 'Date'; // or throw an error, or return null/empty string
    }
  }

  back() {
    this.router.navigate(['/admin/dashboard'])
  }

  goToSummary(assetType: string) {
    this.router.navigate(['/admin/asset-management/' + assetType, {period: this.activePeriodFilter}])
  }






  searchedtransactionsNotFound = false;
  errorFetchingTransactionHistory = false;
  isSearching: boolean = false;

  assetCount: any;
  errorFetchingassetCount: any;

  formatDateToYMD(date: Date): string {
    const year = date?.getFullYear();
    const month = (date?.getMonth() + 1).toString()?.padStart(2, '0');
    const day = date?.getDate()?.toString()?.padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  fetchassetCount(payload: any) {
    this.assetCount = null;

    this.apiService.post('/dashboard/assets-count', { ...payload }).subscribe((res: any) => {

      this.assetCount = res;

    },
      (error) => {
        this.errorFetchingassetCount = true
      })
  }


  lineChartData: any;
  barChartData: any;
  errorFetchingSummaryChartData: any;

  transformToBarChartData(data: {
    approved: { period: string, totalAmount: number }[],
    initiated: { period: string, totalAmount: number }[],
    failed?: { period: string, totalAmount: number }[] // optional
  }) {
    // Get unique periods from any category (assuming all categories share same periods)
    const periods = Array.from(new Set([
      ...data.approved.map(d => d.period),
      ...data.initiated.map(d => d.period),
      ...(data.failed?.map(d => d.period) ?? [])
    ]));

    return periods.map(period => ({
      name: period,
      series: [
        {
          name: "Initiated Transactions",
          value: data.initiated.find(d => d.period === period)?.totalAmount || 0
        },
        {
          name: "Approved Transactions",
          value: data.approved.find(d => d.period === period)?.totalAmount || 0
        },
        // Optional: include failed
        // {
        //   name: "Failed Transactions",
        //   value: data.failed?.find(d => d.period === period)?.totalAmount || 0
        // }
      ]
    }));
  }

  fetchSummaryChartData(payload: any) {


    this.apiService.post('/dashboard/assets-bar-count', payload).subscribe((res: any) => {


      this.barChartData = res?.data?.map((item => ({
        name: item.name,
        series: item.series.map((seriesItem: any) => ({
          name: seriesItem.name,
          value: seriesItem.count
        }))
      })));


      this.totalAssetCount = res.data.reduce((total, item) => {
        const seriesTotal = item.series.reduce((sum, s) => sum + s.count, 0);
        return total + seriesTotal;
      }, 0);

    },
      (error) => {

        this.errorFetchingSummaryChartData = true;

      })
  }




  // Transactions

  transactions: any[] = [
    {
      revenueName: 'Business Permit',
      revenueCode: 'BP001',
      transactionAmount: 250000,
      transactionCount: 15
    },
    {
      revenueName: 'Market Stall Fee',
      revenueCode: 'MSF021',
      transactionAmount: 75000,
      transactionCount: 40
    },
    {
      revenueName: 'Sanitation Levy',
      revenueCode: 'SL013',
      transactionAmount: 56000,
      transactionCount: 30
    },
    {
      revenueName: 'Vehicle Permit',
      revenueCode: 'VP009',
      transactionAmount: 320000,
      transactionCount: 22
    },
    {
      revenueName: 'Liquor License',
      revenueCode: 'LL004',
      transactionAmount: 120000,
      transactionCount: 10
    }

  ];














}
